const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_51_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 405.463,
    y1: 187.751,
    x2: 270.565,
    y2: 52.852
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_50_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 185.366,
    y1: 138.051,
    x2: 320.264,
    y2: 272.95
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_450_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M185.366,138.051l85.199-85.199c9.803-9.803,9.803-25.697,0-35.5v0c-9.803-9.803-25.697-9.803-35.5,0l-85.199,85.199 c-9.803,9.803-9.803,25.697,0,35.5h0C159.669,147.854,175.563,147.854,185.366,138.051z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_449_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M355.764,308.449l85.199-85.199c9.803-9.803,9.803-25.697,0-35.5h0c-9.803-9.803-25.697-9.803-35.5,0l-85.199,85.199 c-9.803,9.803-9.803,25.697,0,35.5l0,0C330.067,318.252,345.961,318.252,355.764,308.449z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_447_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M291.865,244.55L291.865,244.55l-78.099-78.099h0c-15.685,15.685-15.685,41.115,0,56.799l21.3,21.3 C250.75,260.235,276.18,260.235,291.865,244.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_446_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M210.357,219.374L19.256,397.965c-12.042,11.218-12.382,30.189-0.738,41.833c11.395,11.395,29.813,11.31,41.108,0.014 c0.241-0.241,0.483-0.497,0.724-0.753l178.592-191.102"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_445_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 74.046,
    y1: 424.327,
    x2: 33.988,
    y2: 384.269
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_444_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M230.898,502H502v-20.204c0-16.568-13.431-30-30-30H260.898c-16.569,0-30,13.432-30,30V502z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M461.837,451.796v-20.204c0-16.568-13.431-30-30-30H301.061c-16.569,0-30,13.432-30,30v20.204"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuction);
export default __webpack_public_path__ + "static/media/auction.9ea86bf4acae7cb8070aea202c8f6b43.svg";
export { ForwardRef as ReactComponent };